import { FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_FAILURE, FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_REQUEST, FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_SUCCESS, FETCH_BILL_ENTRY_REPORTS_ALL_DATA_FAILURE, FETCH_BILL_ENTRY_REPORTS_ALL_DATA_REQUEST, FETCH_BILL_ENTRY_REPORTS_ALL_DATA_SUCCESS, FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_FAILURE, FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_REQUEST, FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_SUCCESS, FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_FAILURE, FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_REQUEST, FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_SUCCESS, SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_ALL_DK } from "./billEntryReportsAll.actionsType";


export const BILL_ENTRY_REPORTS_ALL = 'billreportsall';

let initialState = {
    loading: false,
    billreportallData: [],
    styleMasterMainList: [],
    supplierWiseData: [],
    renderGridBtn: 'summaryGrid',
    billEntryReportAllDetail: [],
};

export let billEntryReportsAllReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_BILL_ENTRY_REPORTS_ALL_DATA_REQUEST:
        case FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_REQUEST:
        case FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_REQUEST:
        case FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_BILL_ENTRY_REPORTS_ALL_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                billreportallData: updatePayload?.BED
            };
        case FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterMainList: updatePayload
            };
        case FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                supplierWiseData: updatePayload
            };
        case FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                billEntryReportAllDetail: updatePayload?.BED
            };
        case FETCH_BILL_ENTRY_REPORTS_ALL_DATA_FAILURE:
        case FETCH_BILL_ENTRY_REPORTS_ALL_STYLE_WISE_FAILURE:
        case FETCH_BILL_ENTRY_REPORTS_ALL_SUPPLIER_WISE_FAILURE:
        case FETCH_BILL_ENTRY_REPORT_ALL_DETAIL_REPORT_FAILURE:
            return {
                ...state,
                loading: false
            };
        case SET_SUMMARY_GRID_NAME_BILL_ENTRY_REPORT_ALL_DK:
            return {
                ...state,
                renderGridBtn: payload
            };

        default:
            return state;
    }
};